var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stats-bar"},_vm._l((_vm.stats),function(stat){return _c('div',{key:stat.label,staticClass:"stat"},[_c('h2',{staticClass:"num"},[_vm._v(_vm._s(stat.value))]),_c('p',{staticClass:"label"},[_vm._v(_vm._s(stat.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }